import { render } from "./ListaSinistrosAprovacaoView.vue?vue&type=template&id=fdb933de&scoped=true"
import script from "./ListaSinistrosAprovacaoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAprovacaoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAprovacaoView.vue?vue&type=style&index=0&id=fdb933de&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb933de"]])

export default __exports__